<p-tabView>
    <p-tabPanel header="Visibility Group">
        <p-table [value]="visibilityGroup" responsiveLayout="scroll" dataKey="id">
            <ng-template pTemplate="header">
                <tr>
                    <th style="width: 2rem"></th>
                    <th>Name</th>
                    <th>Last Updated</th>
                    <th>Count</th>
                    <th>Is Active</th>
                    <th>Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-data let-expanded="expanded">
                <tr style="background: #f1f1f1;">
                    <td class="action">
                        <button type="button" pButton pRipple [pRowToggler]="data" class="p-button-text p-button-rounded p-button-plain" [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                    </td>
                    <td>{{data.name}}</td>
                    <td>{{data.lastUpdated | localDate}} by {{data.lastUpdatedBy}}</td>
                    <td>{{data.count ? data.count : '-'}}</td>
                    <td>{{data.statusId == 1 ? answertypeConstants.Yes : data.statusId == 2 ? answertypeConstants.No : ''}}</td>

                    <td class="action">
                        <span class="btnBars p-mr-0" (click)="editVisibilityGroup(data)" pTooltip="Edit" tooltipPosition="top">
                            <i class="pi pi-pencil"></i>
                        </span>
                        <span class="btnBars p-mr-0" (click)="deleteVisibilityConfirmation(data)" pTooltip="Delete" tooltipPosition="top">
                            <i class="pi pi-trash"></i>
                        </span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-data>
                <ng-container *ngFor="let child of data.children;">
                    <tr>
                        <td></td>
                        <td>
                            <span class="p-ml-3">{{child.objectName}}</span>
                        </td>
                        <td></td>
                        <td>
                            <span class="pointer" style="color: var(--primary-color);" *ngIf="child.objectcount> 0 || child?.allSelect"  pTooltip="View" tooltipPosition="top" (click)="viewResource(data, child)">
                                {{child.allSelect ? 'All '+child.objectName+'s' : child.objectcount}}
                            </span>
                        </td>
                        <td>
                            <!-- <span class="pointer" style="color: var(--primary-color);" *ngIf="child.objectcount> 0"
                                pTooltip="View" tooltipPosition="top" (click)="viewResource(data, child)">
                                    {{child.userGroupCount}}
                            </span> -->

                        </td>

                        <td>
                            <!-- <span class="btnBars p-mr-0" pTooltip="Add User Group" tooltipPosition="top"
                            (click)="addUserGroup(data, child)">
                                <i class="pi pi-user-plus"></i>
                            </span> -->

                            <span *ngIf="data.statusId === 1" class="btnBars p-mr-0" pTooltip="Add" tooltipPosition="top" (click)="addResource(data, child)">
                                <i class="pi pi-plus"></i>
                            </span>
                            <span class="btnBars p-mr-0" pTooltip="View" tooltipPosition="top" (click)="viewResource(data,child)">
                                <i class="pi pi-list"></i>
                            </span>
                        </td>
                    </tr>
                </ng-container>
            </ng-template>
        </p-table>
    </p-tabPanel>
    <p-tabPanel [disabled]="true" headerStyleClass="iconPanel">
        <ng-template pTemplate="header">
            <p-menu #configmenuUser id="config_menu_user" [model]="configMenuProfileItems" [popup]="true" appendTo="body"></p-menu>
            <span class="btnBars p-mr-0" (click)="configmenuUser.toggle($event)">
            <i class="pi pi-bars"></i>
          </span>
        </ng-template>
    </p-tabPanel>
</p-tabView>


<!-- Add Edit Visit -->
<p-dialog header="{{addEditVisibilityHeader}}" [modal]="true" [(visible)]="displayAddEditVisibilityModal" [style]="{width: '60vw'}" [baseZIndex]="10000" (onHide)="closeVisibilityAddEditModal()">
    <form [formGroup]="addEditVisibilityForm">
        <div class="header">
            <h5>
                Group Information
                <p-inputSwitch class="header-switch" formControlName="isActive">
                </p-inputSwitch>
            </h5>
        </div>
        <div class="card">
            <div class="p-grid">
                <div class="p-col-12">
                    <label>Name</label>
                    <input type="text" pInputText formControlName="name">
                    <small *ngIf="name.invalid && (name.touched || name.dirty)" class="p-invalid">
                        <span *ngIf="name.errors?.['required']" class="p-invalid">
                           Name is required
                        </span>
                    </small>
                </div>
            </div>
            <div class="p-grid">
                <div class="p-col-12">
                    <label>Description</label>
                    <textarea pInputTextarea name="description" rows="5" formControlName="description"></textarea>
                </div>
            </div>
        </div>
    </form>

    <ng-template pTemplate="footer">
        <button pButton (click)="closeVisibilityAddEditModal()" label="Cancel" class="p-button-secondary"></button>
        <button pButton (click)="saveVisibilityGroup()" [disabled]="addEditVisibilityForm.invalid" label="Save"></button>
    </ng-template>
</p-dialog>

<p-dialog header="User Group" [modal]="true" [(visible)]="displayUserGroupTB" [style]="{width: '60vw'}" [baseZIndex]="10000">
    <div class="card" style="margin-bottom: 50px;">
        <p-table [value]="allUserGroup" [loading]="loading" selectionMode="multiple" [(selection)]="selectedUserGroups" dataKey="id" [paginator]="true" [rows]="10" [showCurrentPageReport]="true" [(first)]="first" responsiveLayout="scroll" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[10,25,50]">
            <ng-template pTemplate="header">
                <tr [pSelectableRow]="userGroup">
                    <th>{{'Configuration.User.Group_Name' | transloco}}</th>
                    <th>{{'Configuration.User.Group_Owner' | transloco}}</th>
                    <th>{{'Configuration.User.Last_Updated' | transloco}}</th>
                    <th>{{'Configuration.User.Is_Active' | transloco}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-userGroup let-rowIndex="rowIndex">
                <tr [pSelectableRow]="userGroup" [pSelectableRowIndex]="rowIndex">
                    <td>{{userGroup.group.name}}</td>
                    <td>{{userGroup.ownerList}}</td>
                    <td>{{(userGroup.group.updatedDate!=null?(userGroup.group.updatedDate | date: 'MM/dd/yyyy'):'NA')}}
                    </td>
                    <td>{{userGroup.statusId == 1 ? 'Yes': 'No'}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="displayUserGroupTB=false" label="{{'Configuration.User.Cancel' | transloco}}" class="p-button-secondary"></button>
        <button pButton (click)="saveUserGroup()" label="{{'Configuration.User.Save' | transloco}}"></button>
    </ng-template>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="displaySelectedUserGroupTB" [style]="{width: '60vw'}" [baseZIndex]="10000">
    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: space-between; width: 100%;">
            <h5 class="p-mb-0">
                User Group
            </h5>
            <button pButton (click)="showEditUserGroupFromView()" class="p-button-text p-button-rounded" icon="pi pi-pencil"></button>
        </div>
    </ng-template>
    <div class="card" style="margin-bottom: 50px;">
        <p-table [value]="allUserGroupForView" #dt [paginator]="true" [rows]="rows" [showCurrentPageReport]="true" [(first)]="first" responsiveLayout="scroll" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['group.name', 'ownerList']"
            [rowsPerPageOptions]="[10,25,50]">
            <ng-template pTemplate="caption">
                <div class="p-text-right">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search"></i>
                        <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search keyword" />
                    </span>
                </div>
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th>Group Name</th>
                    <th>Group Owner</th>
                    <th>Last Updated</th>
                    <th>Is Active</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-userGroup let-rowIndex="rowIndex">
                <tr>
                    <td>{{userGroup.group.name}}</td>
                    <td>{{userGroup.ownerList}}</td>
                    <td>{{(userGroup.group.updatedDate!=null?(userGroup.group.updatedDate | date: 'MM/dd/yyyy'):'NA')}}
                    </td>
                    <td>{{userGroup.statusId == 1 ? 'Yes': 'No'}}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="displaySelectedUserGroupTB=false" label="{{'Configuration.User.Cancel' | transloco}}" class="p-button-secondary"></button>
    </ng-template>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="displaySelectedJobTypeUsersTB" [style]="{width: '60vw'}" [baseZIndex]="10000">
    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: space-between; width: 100%;">
            <h5 class="p-mb-0">
              {{ addJobTypeUserEnable ? 'Add Users from Job Type' : 'Added Users' }}
            </h5>
            <button *ngIf="!addJobTypeUserEnable && selectedVisibilityGroup?.statusId === 1" pButton (click)="addJobTypeUserEnable=true" class="p-button-text p-button-rounded" icon="pi pi-pencil"></button>
        </div>
    </ng-template>
    <div class="card" style="margin-bottom: 50px;">
        <ng-container *ngIf="addJobTypeUserEnable">
            <p-table [value]="jobTypeListByVisibility" responsiveLayout="scroll">
                <ng-template pTemplate="header">
                    <tr>
                        <th>Job Type</th>
                        <th style="text-align: center">Associated Users</th>
                        <th style="text-align: center">Total Users</th>
                        <th class="action" style="text-align: right">Action</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-jobType let-rowIndex="rowIndex">
                    <tr>
                        <td>{{jobType.name}}</td>
                        <td style="text-align: center"><span (click)="showJobTypeDialog(jobType)" class="pointer" style="color: var(--primary-color);">{{jobType?.addedUsers?.length||0}}</span></td>
                        <td style="text-align: center"><span (click)="showJobTypeDialog(jobType)" class="pointer" style="color: var(--primary-color);">{{jobType.noOfAssociatedUsers}}</span></td>
                        <td class="action" style="text-align: right">
                            <span class="btnBars p-mr-0" pTooltip="Add User" tooltipPosition="top" (click)="showJobTypeDialog(jobType)">
                                <i class="pi pi-plus"></i>
                            </span>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </ng-container>

        <ng-container *ngIf="!addJobTypeUserEnable">
            <p-table [value]="assignedJobTypeUsers" #jobTypeTable [paginator]="true" [rows]="rows" [showCurrentPageReport]="true" [(first)]="first" responsiveLayout="scroll" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="[10,25,50]"  [globalFilterFields]="['jobTypeName', 'userName', 'userEmail']">
                <ng-template pTemplate="caption">
                    <div class="p-text-right">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="jobTypeTable.filterGlobal($event.target.value, 'contains')" placeholder="Search keyword" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th></th>
                        <th>User Name</th>
                        <th>User Email</th>
                        <th>Job Type</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-userDetails let-rowIndex="rowIndex">
                    <tr>
                        <td class="user-display">
                            <img [src]="userDetails?.profileImageUrl ? userDetails.profileImageUrl : defaultProfileImage" />
                        </td>
                        <td>{{userDetails.userName}}</td>
                        <td>{{userDetails.userEmail}}</td>
                        <td>{{userDetails.jobTypeName}}</td>
                    </tr>
                </ng-template>
            </p-table>
        </ng-container>
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="displaySelectedJobTypeUsersTB=false" label="{{'Configuration.User.Cancel' | transloco}}" class="p-button-secondary"></button>
        <button *ngIf="addJobTypeUserEnable" pButton (click)="saveJobTypeUser()" label="{{'Configuration.User.Save' | transloco}}"></button>
    </ng-template>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="displaySelectJobTypeUsersTB" [style]="{width: '50vw'}" [baseZIndex]="10000">
    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: space-between; width: 100%;">
            <h5 class="p-mb-0">
                Select Users
            </h5>
        </div>
    </ng-template>
    <div class="card" style="margin-bottom: 50px;">
        <p-table
            [value]="allJobTypeUsers"
            selectionMode="multiple"
            [(selection)]="selectedJobTypeUsers" dataKey="userId"
            #selectUserTable [paginator]="true" [rows]="10"
            [showCurrentPageReport]="true" responsiveLayout="scroll"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            [rowsPerPageOptions]="[15,30,50]"
            [globalFilterFields]="['name', 'emailAddress']"
            (onRowSelect)="onUserSelect()"
            (onRowUnselect)="onUserUnselect()">
            <ng-template pTemplate="caption">
                <div class="p-d-flex p-ai-center">
                    <div class="p-field-checkbox p-mb-0">
                        <p-checkbox value="true" (click)="includeAllUsersToggle(true)" [(ngModel)]="selectedJobTypeUsersToggle" [ngStyle]="{verticalAlign: 'middle' }" binary="true" inputId="selectAllUsers"></p-checkbox>
                        <label for="selectAllUsers" style="padding: 5px;margin:0px">Select All Users</label>
                    </div>
                    <div class="p-ml-auto p-text-right">
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="selectUserTable.filterGlobal($event.target.value, 'contains')" placeholder="Search keyword" />
                        </span>
                    </div>
                </div>

            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th></th>
                    <th>User Name</th>
                    <th>Email</th>
                    <th>Job Type</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user let-rowIndex="rowIndex">
                <tr [pSelectableRow]="user" [pSelectableRowIndex]="rowIndex">
                    <td class="user-display">
                        <img [src]="user.profileImageUrl ? user.profileImageUrl : defaultProfileImage" />
                    </td>
                    <td>{{ user.name }}</td>
                    <td>{{ user.emailAddress }}</td>
                    <td>{{ selectedJobType?.name }}</td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="displaySelectJobTypeUsersTB=false" label="{{'Configuration.User.Cancel' | transloco}}" class="p-button-secondary"></button>
        <button pButton (click)="includeUsers()" label="{{'Configuration.User.Save' | transloco}}"></button>
    </ng-template>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="displayAddAccountsOrLeads" [style]="{width: '50vw'}" [baseZIndex]="10000" [closable]="false">
    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: space-between; width: 100%;">
            <h5 class="p-mb-0">
                {{addAccountsOrLeadsHeader}}
            </h5>
            <div class="btn-group">
                <!-- <button pButton (click)="showColumnSetting()"
                pTooltip="Column Setting" tooltipPosition="top" *ngIf="layerNo == 2"
                class="p-button-text p-button-rounded" icon="pi pi-cog"></button> -->
                <button pButton (click)="closeAddAccountOrLeadModal()" class="p-button-text p-button-rounded" icon="pi pi-times"></button>
            </div>
        </div>
    </ng-template>
    <div class="card">
        <ng-container>
            <div class="p-grid">
                <div class="p-col-12">
                    <label>Module <span style="color:red">*</span></label>
                    <p-dropdown
                        appendTo="body"
                        [options]="allModules"
                        name="allModules"
                        [(ngModel)]="selectedModule"
                        optionLabel="name"
                        id="allModules"
                        dataKey="id"
                        placeholder="Select a  Module"
                        (onChange)="getChannels(selectedModule)"
                        required
                        [disabled]="true">
                    </p-dropdown>
                </div>
                <div *ngIf="!selectAllRecords" class="p-col-12">
                    <label>Channel <span style="color:red">*</span></label>
                    <p-dropdown
                        appendTo="body"
                        [options]="allChannels"
                        name="allChannels"
                        [(ngModel)]="selectedChannel"
                        optionLabel="name"
                        id="allChannels"
                        dataKey="id"
                        placeholder="Select Channel"
                        required
                        (onChange)="changeChannel(selectedChannel)">
                    </p-dropdown>
                </div>
                <div class="p-col-12">
                    <div class="p-field-checkbox">
                        <p-checkbox [(ngModel)]="selectAllRecords" [ngStyle]="{verticalAlign: 'middle' }" binary="true" inputId="selectAll"></p-checkbox>
                        <label for="selectAll" style="padding: 5px;margin:0px">Select All {{ selectedModule?.name+'s' }}</label>
                    </div>
                </div>
            </div>
        </ng-container>
        <!-- <ng-container *ngIf="layerNo == 2">

            <app-shared-manual-modal
                [source]="sourceModuleName"
                [displayPopup]="displayModuleDataList"
                [colsList]="moduleColumnSetttings"
                [selectedObjectType]="selectedModule"
                [selectedTemplateType]="selectedChannel"
                [selectedItem]="selectedRecordList"
                (saveAssignDataclicked)="saveAssignData($event)">
            </app-shared-manual-modal>
        </ng-container> -->
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="closeAddAccountOrLeadModal()" label="{{'Configuration.User.Cancel' | transloco}}" class="p-button-secondary"></button>
        <button type="button" *ngIf="selectedModule && selectedChannel" pButton class="p-button-success" [label]="selectAllRecords? 'Save' :'Next'" (click)="selectAllRecords ? saveAssignData(null,true) : getDataLists()"></button>
    </ng-template>
</p-dialog>

<div *ngIf="displayModuleDataList ">
    <app-shared-manual-modal
        [headerTitle]="manualHeaderTitle"
        [viewOnly]="manualViewOnly"
        [displayPopup]="displayModuleDataList"
        [source]="sourceModuleName"
        [colsList]="moduleColumnSetttings"
        [selectedObjectType]="selectedModule"
        [selectedTemplateType]="selectedChannel"
        [selectedItem]="selectedRecordList"
        (saveAssignDataclicked)="saveAssignData($event)"
        (backToModuleClicked)="backToModuleClicked()"
        (cancelClicked)="cancelClickedModuleDataList()">
    </app-shared-manual-modal>
</div>

<p-dialog header="Selected Lists" [modal]="true" [(visible)]="displayAccountDataListForView" [style]="{width: '85vw'}" [baseZIndex]="10000" (onHide)="closeAccountDataListForView()">
    <div class="card" style="margin-bottom: 100px;">
        <!-- Account -->
        <p-table #accountsTable [columns]="moduleCols" class="accountTable" [(first)]="first" [scrollable]="true" [lazy]="false" [totalRecords]="totalRecords" [loading]="loadingTable" [style]="{width:'100%'}" [value]="selectedRecordListDetails" [rows]="pageSize"
            [paginator]="true" dataKey="id" [expandedRowKeys]="expandedRows" [expandableRows]="true" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [rowsPerPageOptions]="tableShowMore" *ngIf="tableSelection?.objectName == 'Account'">
            <ng-template pTemplate="colgroup" let-columns>
                <colgroup>
                    <!-- <col style="width:40px; max-width: 40px;"> -->
                    <ng-container *ngFor="let col of columns">
                        <col *ngIf="col.enabled" style="width:auto">
                    </ng-container>
                </colgroup>
            </ng-template>

            <ng-template pTemplate="header" let-columns>
                <tr>
                    <!-- <th id="id" style="width: 40px; max-width: 40px;"></th> -->
                    <ng-container *ngFor="let col of columns">
                        <th *ngIf="col.enabled" [pSortableColumn]="col.columnName" style="min-width:116.05px">
                            {{col.name}}
                            <p-sortIcon style="margin-right: 3px;" [field]="col.columnName" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                            <!-- <span class="pi pi-filter p-mr-2 filtericon"
                     [ngClass]="{'blink_me' : col.value && col.value.length > 0}"
                     (click)="$event.stopPropagation(); currentCol = col; filters.toggle($event)">
                 </span> -->
                        </th>
                    </ng-container>
                    <th  *ngIf="selectedVisibilityGroup.statusId===1">Actions</th>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded">
                <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                    <!-- start for space rowexpansion -->
                    <!-- <td style="width: 40px; max-width: 40px;height: 40px;"
             *ngIf="rowData.hasChildAccounts; else selectionEnabledTemplate">
             <button type="button" [pRowToggler]="rowData" pButton pRipple
                 class="p-button-text p-button-rounded p-button-plain"
                 style="height: 1.25rem;"
                 (click)="onExpandRow(rowData?.id, rowData, expanded)"
                 [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
         </td>
         <ng-template #selectionEnabledTemplate>
             <td style="width: 40px; max-width: 40px;"></td>
         </ng-template> -->
                    <!-- end for space rowexpansion -->
                    <ng-container *ngFor="let col of columns">
                        <td *ngIf="col.enabled" style="text-align: left;min-width: 116.05px;word-break: break-all;">
                            <ng-container *ngIf="!col?.depth; else depthTemplate">
                                <ng-container *ngIf="col.columnName =='businessName'">
                                    <app-color-box class="colorBoxStyle" [color]="rowData.classificationColor">
                                    </app-color-box>
                                </ng-container>
                                <ng-container *ngIf="col.columnName =='tags'">
                                    <ng-container *ngFor="let s of rowData?.tags; let i = index">
                                      <p-tag styleClass="p-ml-1" [value]="s?.name" [style]="{'background-color': s.color}"></p-tag>
                                    </ng-container>
                                </ng-container>

                                <ng-container *ngIf="['twitter','website', 'facebook','linkedin','instagram',
                                         'contactsocialtwitter','contactsocialwebsite','contactsocialfacebook',
                                         'contactsociallinkedin','contactsocialinstagram'].indexOf(col.columnName) >= 0;
                                         else elseData">
                                    <a href="{{rowData[col.columnName] | url}}" target="_blank">{{
                                    rowData[col.columnName] | shorten }}</a>
                                </ng-container>
                                <ng-template #elseData>
                                    <ng-container *ngIf="col.columnName != 'tags'">
                                    <ng-container [ngSwitch]="col?.fieldDataType">
                                        <ng-container *ngSwitchCase="'DateTime'">
                                          {{ rowData[col.columnName] | date:'MM/dd/yyyy' }}
                                        </ng-container>
                                        <ng-container *ngSwitchDefault>
                                          <span>{{rowData[col.columnName] | shorten:27}}</span>
                                        </ng-container>
                                      </ng-container>
                                    </ng-container>
                                    <!-- {{ rowData[col.columnName] | shorten:27 }} -->
                                </ng-template>
                            </ng-container>
                            <ng-template #depthTemplate>
                                {{ rowData | columnName:col?.depth }}
                            </ng-template>
                        </td>
                    </ng-container>
                    <td  *ngIf="selectedVisibilityGroup.statusId===1">
                        <span class="btnBars p-mr-0"  (click)="onDeleteSelectedList(rowData, selectedRecordListDetails)"
                        pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="rowexpansion" let-rowData let-columns="columns" #depth>
                <ng-template [ngTemplateOutlet]="Recursion" [ngTemplateOutletContext]="{$implicit: rowData, columns:columns}"></ng-template>
            </ng-template>
            <ng-template let-rowData let-columns="columns" #Recursion>
                <!-- @@@ {{rowData[0].childAccount}} -->
                <ng-container *ngFor="let children of rowData.childAccount">
                    <ng-container *ngIf="rowData.viewDetails">
                        <tr class="child-color" [pSelectableRow]="children" [pContextMenuRow]="children">
                            <!-- start for space rowexpansion -->
                            <td style="width: 40px; max-width: 40px;" *ngIf="children.hasChildAccounts; else selectionEnabledTemplate">
                                <button type="button" [pRowToggler]="children" pButton pRipple class="p-button-text p-button-rounded p-button-plain" (click)="onExpandRow(children?.id, children, children.viewDetails)" [icon]="children.viewDetails ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                            </td>
                            <ng-template #selectionEnabledTemplate>
                                <td style="width: 40px; max-width: 40px;"></td>
                            </ng-template>
                            <!-- end for space rowexpansion -->
                            <ng-container *ngFor="let col of columns">
                                <td *ngIf="col.enabled" style="text-align: left;">
                                    <ng-container *ngIf="!col?.depth; else depthTemplateChild">
                                        <ng-container *ngIf="col.columnName =='businessName'">
                                            <app-color-box class="colorBoxStyle" [color]="children.classificationColor">
                                            </app-color-box>
                                        </ng-container>
                                        <ng-container *ngIf="['twitter','website','other','facebook','linkedin','instagram'].indexOf(col.columnName) >= 0; else elseData">
                                            <a href="{{children[col.columnName] | url}}" target="_blank">{{children[col.columnName] |
                                     shorten}}</a>
                                        </ng-container>
                                        <ng-template #elseData>
                                            {{children[col.columnName] | shorten:27 }}
                                        </ng-template>
                                    </ng-container>
                                    <ng-template #depthTemplateChild>
                                        {{children | columnName:col?.depth }}
                                    </ng-template>
                                </td>
                            </ng-container>
                            <td>
                                <span class="btnBars p-mr-0"
                                pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                            </td>
                        </tr>
                        <ng-container *ngIf="children.childAccount && children.childAccount.length>0">
                            <ng-template [ngTemplateOutlet]="depth" [ngTemplateOutletContext]="{$implicit: children, columns:columns }">
                            </ng-template>
                        </ng-container>
                    </ng-container>

                </ng-container>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="9">{{noAccountFindOrLoadingText}}</td>
                </tr>
            </ng-template>

        </p-table>
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="closeAccountDataListForView()" label="{{'Configuration.User.Cancel' | transloco}}" class="p-button-secondary"></button>
    </ng-template>
</p-dialog>

<p-dialog header="Selected Lists" [modal]="true" [(visible)]="displayLeadDataListForView" [style]="{width: '85vw'}" [baseZIndex]="10000" (onHide)="closeLeadDataListForView()">
    <div class="card" style="margin-bottom: 100px;">

        <!-- Lead -->
        <p-table #leadsTable [columns]="moduleCols" [lazy]="false" [totalRecords]="totalRecords" [loading]="loadingTable" [value]="selectedRecordListDetails" [rows]="rows" [scrollable]="true" [style]="{width:'100%'}" [paginator]="true" [showCurrentPageReport]="true"
            [rowsPerPageOptions]="tableShowMore" dataKey="id" [(first)]="first" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" *ngIf="tableSelection?.objectName == 'Lead'">
            <ng-template pTemplate="colgroup" let-columns>
                <colgroup>
                    <ng-container *ngFor="let col of columns">
                        <col *ngIf="col.enabled" style="width:auto">
                    </ng-container>
                </colgroup>
            </ng-template>
            <ng-template pTemplate="header" let-columns>
                <tr>
                    <ng-container *ngFor="let col of columns;">
                        <th *ngIf="col.enabled" [pSortableColumn]="col.columnName" style="min-width:116.05px">
                            {{col.name}}
                            <p-sortIcon [field]="col.columnName" ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order">
                            </p-sortIcon>
                            <!-- <span class="pi pi-filter p-ml-2 filtericon"
                            (click)="$event.stopPropagation(); curCol = col; op.toggle($event)">
                        </span> -->
                        </th>
                    </ng-container>
                   <th *ngIf="selectedVisibilityGroup.statusId===1">Action</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData let-columns="columns">
                <tr [pSelectableRow]="rowData" [pContextMenuRow]="rowData">
                    <ng-container *ngFor="let col of columns">

                        <td *ngIf="col.enabled" style="text-align: left;min-width: 116.05px;word-break: break-all;">
                            <ng-container *ngIf="!col?.depth; else depthTemplate">
                                <ng-container *ngIf="col.columnName =='businessName'">
                                    <app-color-box class="colorBoxStyle" [color]="rowData.classificationColor">
                                    </app-color-box>
                                </ng-container>
                                <ng-container *ngIf="col.columnName =='tags'">
                                    <ng-container *ngFor="let s of rowData?.tags; let i = index">
                                      <p-tag styleClass="p-ml-1" [value]="s?.name" [style]="{'background-color': s.color}"></p-tag>
                                    </ng-container>
                                </ng-container>
                                <ng-container *ngIf="['twitter','website','other','facebook','linkedin','instagram',
                                'contactsocialtwitter','contactsocialwebsite','contactsocialfacebook',
                                'contactsociallinkedin','contactsocialinstagram']
                                .indexOf(col.columnName) >= 0; else elseData">
                                    <a href="{{rowData[col.columnName] | url}}" target="_blank">{{rowData[col.columnName] | shorten }}</a>
                                </ng-container>
                                <ng-template #elseData>
                                    <div>
                                        <ng-container *ngIf="col.columnName != 'tags'">
                                        <ng-container [ngSwitch]="col?.fieldDataType">
                                            <ng-container *ngSwitchCase="'DateTime'">
                                              {{ rowData[col.columnName] | date:'MM/dd/yyyy' }}
                                            </ng-container>
                                            <ng-container *ngSwitchDefault>
                                              <span>{{rowData[col.columnName] | shorten:27}}</span>
                                            </ng-container>
                                          </ng-container>
                                        </ng-container>
                                        <span *ngIf="col.columnName === 'currentStage' && rowData.isConvertedToAccount
                                        && rowData.leadStageId==qualifiedId">
                                            *
                                        </span>
                                    </div>
                                </ng-template>
                            </ng-container>
                            <ng-template #depthTemplate>
                                {{rowData | columnName:col?.depth }}
                            </ng-template>
                        </td>
                    </ng-container>
                    <td style="text-align: left;" *ngIf="selectedVisibilityGroup.statusId===1">
                        <span (click)="onDeleteSelectedList(rowData, selectedRecordListDetails)"
                        pTooltip="Delete" tooltipPosition="top"><i class="pi pi-trash"></i></span>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="7">
                        <div class="p-text-center">{{noLeadFindOrLoadingText}}</div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
    <ng-template pTemplate="footer">
        <button pButton (click)="closeLeadDataListForView()" label="{{'Configuration.User.Cancel' | transloco}}" class="p-button-secondary"></button>
    </ng-template>
</p-dialog>
